import { render, staticRenderFns } from "./DateInput2.vue?vue&type=template&id=6f45e534&"
import script from "./DateInput2.vue?vue&type=script&lang=js&"
export * from "./DateInput2.vue?vue&type=script&lang=js&"
import style0 from "./DateInput2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports